import { HOUR, type RatioData, type RatioListInput, type RatioListSuccess } from '@terros/common'
import { useTantalimQuery } from '../query'
import { ratioListKey } from '../keys'
import { type GetHookResponse } from '../hooks'

type Input = Pick<RatioListInput, 'scopeId' | 'workflowId'>
export const useRatios = (input: Input = {}): GetHookResponse<RatioData[]> => {
  const { scopeId, workflowId } = input
  return useTantalimQuery<RatioListInput, RatioListSuccess, RatioData[]>({
    url: '/ratio/list',
    queryKey: ratioListKey({ scopeId, workflowId }),
    input,
    convertResponse: (data) => data.ratios,
    options: {
      enabled: !!scopeId,
      staleTime: HOUR,
      gcTime: 3 * HOUR,
    },
  })
}
